<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Página em Branco' action='Visualizar' btnLink='/home' btnTxt='Ação'/>

      <div class="wrapper wrapper-content animated fadeIn">

        <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

        <!-- CONTEÚDO DA PÁGINA AQUI -->

      </div>

      <page-footer></page-footer>

    </div>
  </div>
</template>

<script>

import NavMenu from './layout/NavMenu'
import SideMenu from './layout/SideMenu'
import BreadCrumps from './layout/BreadCrumps'
import PageFooter from './layout/PageFooter'
import Spinner from './layout/Spinner'
import { httpService } from '../providers/http-service'
import { toast } from '../mixins/toast'

  export default {
    mixins: [ toast ],
    components: { NavMenu, SideMenu, BreadCrumps, PageFooter, Spinner },
    data () {
      return {
        showSpinner: false
      }
    },
    methods: {

    },
    mounted() {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BlankPage.vue